export default __webpack_public_path__ + "static/media/Locandina-annullato.e0351762.jpg";